import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  registrationError: null,
  message: null,
  loading: false,
  entity: null,
  success: false,
  error: false,
  isentityLogout: true,
};

const registerSlice = createSlice({
  name: "registerEntity",
  initialState,
  reducers: {
    registerEntitySuccessful(state, action) {
      state.entity = action.payload;
      state.loading = false;
      state.success = true;
      state.registrationError = null;
    },
    registerEntityFailed(state, action) {
      state.entity = null;
      state.loading = false;
      state.registrationError = action.payload;
      state.error = true;
    },
    resetRegisterFlagChange(state) {
      state.success = false;
      state.error = false;
    },
    apiErrorChange(state, action) {
      state.error = action.payload;
      state.loading = false;
      state.isentityLogout = false;
    },
  },
});

export const {
  registerEntitySuccessful,
  registerEntityFailed,
  resetRegisterFlagChange,
  apiErrorChange,
} = registerSlice.actions;

export default registerSlice.reducer;
